// extracted by mini-css-extract-plugin
export var col = "DownloadsImages-module--col--wBh4W";
export var container = "DownloadsImages-module--container--y4ZtI";
export var header = "DownloadsImages-module--header--2lxm9";
export var row = "DownloadsImages-module--row--Uds7o";
export var section = "DownloadsImages-module--section--+FM0H";
export var sectionBg = "DownloadsImages-module--section-bg--AZwCS";
export var subheader = "DownloadsImages-module--subheader--VkY7A";